import React, { useEffect, useRef, useState, useContext } from 'react'
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import Card from '../../../../Base/Components/Card/Card'
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';

// import PosicionesCrudModal from './PosicionesCRUD/PosicionesCrudModal';
import { getBandeja } from '../../../../API/Suministros/SuministrosRequest';
import { setTitlePage } from '../../../../Base/Services/Config/ConfigService';
import BandejaCrudModal from './BandejaCRUD/BandejaCrudModal';

const BandejaScreen = ({ enModal = false }) => {
    const toast = useRef(null);
    const { config } = useContext(ConfigContext);
    const { userAuth } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [bandeja, setBandeja] = useState([]);
    const [selected, setSelected] = useState([]);
    const [showDialog, setShowDialog] = useState(false);

    const getInfo = async () => {
        setLoading(true);
        const d = await getBandeja();
        // console.log(d);
        setBandeja(d);
        setLoading(false);
    };

    const columns = [
        {
          header: "ID",
          headerEn:"ID",
          field: "IdBandeja",
          hidden: userAuth.IdRol === 1,
          className: "Xsmall",
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
        },
        {
          header: "Nombre de Posición",
          headerEn:"Tray Name",
          field: "NombreBandeja",
          flex:'1',
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
          Sumary: 'count'
        },
        {
          header: "Número de Bandeja",
          headerEn:"Tray Number",
          field: "NumeroBandeja",
          className: "small",
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
        },
        {
          header: "Lado",
          headerEn:"Lado",
          field: "Lado",
          className: "small"
        },
        {
          header: "Nombre de Bodega",
          headerEn:"Warehouse Name",
          field: "NombreBodega",
          className: 'XXXlarge',
        },
        {
          header: "Nombre de Estante",
          // headerEn:"Warehouse Name",
          field: "NombreEstante",
          className: "small"
        },
        {
          header: "Nombre de Fila",
          headerEn:"Position Name",
          field: "NombrePosicion",
          className: "small"
        },
        {
          header: "Estado",
          headerEn: "Status",
          field: "IdEstado",
          className: "small",
          Format: "Estado", 
          filter: false,    
          body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
        },
        {
          field: "IdBandeja",
          className: "",
          header: "",
          Format: "Botones",
          frozen: true,
          alignFrozen: "right",
          filter: false,
          Botones: [
            {
              icon: "pi pi-pencil",
              tooltip: "Editar",
              onClick: (rowData) => {
                setShowDialog(true);
                setSelected(rowData);
              },
            },
          ],
        },
    ]

    const table = {
        Columns: columns,
        Data: bandeja,
        loading: loading
    };


    useEffect(() => {
      setTitlePage(getLabel(baseLang, "bandeja", config.language));
      getInfo();
    }, []);



    return (
        <div
        className=" p-fluid px-4"
        style={{ width: "100%", height: "100%", margin: "auto" }}
        >
            <Toast ref={toast} />
            <Card
                titulo={
                <div className='botones'>
                    <h3>{getLabel(baseLang, "Posición", config.language)}</h3>
                    <Button icon='pi pi-refresh' onClick={getInfo} />
                    <Button icon='pi pi-plus' severity='success' onClick={() => {
                        setShowDialog(true);
                        setSelected(null);
                    }} />
                </div>}
                contenido={
                  <div className="p-4" style={{ height: enModal ? "65vh" : "90vh" }}>
                    <AgGrid table={table} />
                  </div>
                }
            />

            {showDialog && <BandejaCrudModal listBandejas={bandeja} toastRef={toast} bandejaDialog={showDialog} bandeja={selected} setBandejaDialog={setShowDialog} getPos={getInfo} modo={selected ? "Editar" : "Crear"}/>}

        </div>
    )
}

export default BandejaScreen;

